/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createChainClass } from '../../factoriesAny.js';
export var ChainDependencies = {
  createChainClass: createChainClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesChainClass.generated.js
// module id = 620
// module chunks = 0